import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { TeamType } from '@graphql-nexus-types';
import { AppService } from '@services/app.service';
import { defaultIfEmpty, of, switchMap } from 'rxjs';

export const hasTeamGuard = (
  type: Array<TeamType | undefined> | TeamType | undefined,
  unauthorizedURL = 'unauthorized',
  router = inject(Router),
  appService = inject(AppService)
) => {
  return appService.user$.pipe(
    switchMap((user) => {
      if (user.teams?.length > 0) {
        return of(true);
      }

      return of(router.parseUrl(unauthorizedURL));
    }),
    // No user when fetching it failed: stay on the current page rather than
    // failing the navigation (`false` from canMatch would mean "no route").
    defaultIfEmpty(router.parseUrl(router.url))
  );
};
